var map = {
	"./page-0.png": 888,
	"./page-1.png": 889,
	"./page-10.png": 890,
	"./page-11.png": 891,
	"./page-12.png": 892,
	"./page-13.png": 893,
	"./page-14.png": 894,
	"./page-15.png": 895,
	"./page-16.png": 896,
	"./page-2.png": 897,
	"./page-3.png": 898,
	"./page-4.png": 899,
	"./page-5.png": 900,
	"./page-6.png": 901,
	"./page-7.png": 902,
	"./page-8.png": 903,
	"./page-9.png": 904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 887;